/**
 * Public name of a provider (Lot 13).
 *
 * Public pages show the provider's COMMERCIAL name only. When there is none, a neutral label in the visitor's
 * language ("Prestataire Ridalo" / "Ridalo provider"). The account holder's own name — which the listing document
 * also carries as `provider_name` — is never a fallback: this function reads `provider_business_name` and nothing else.
 */
import i18n from '@/i18n';

/** The commercial name of a public listing / payload, or '' when it has none. */
export const businessNameOf = (source) => String((source && source.provider_business_name) || '').trim();

/** Neutral label in `lang` ('fr' | 'en'; the current interface language by default). */
export const neutralProviderName = (lang) => i18n.t('common.neutralProvider', lang ? { lng: String(lang).toLowerCase().startsWith('en') ? 'en' : 'fr' } : undefined);

/** Name to show for a public listing: its commercial name, else the neutral label. */
export const publicProviderName = (source, lang) => businessNameOf(source) || neutralProviderName(lang);
